// Só clientes podem comprar. O login de cliente (/login/clients) devolve
// `role: "client"`; o de admin/master devolve `type: "admin" | "master"`.
export function isClientUser(user) {
  return user?.info?.role === "client";
}
